import { wrapFunction } from '../utils';

export const TIMESTAMP = () => {
    return new Date().toISOString()
};

export default wrapFunction(TIMESTAMP, {
    name: 'TIMESTAMP',
    nargs: 0,
    types: [],
});
